import React, { useState } from "react";
import { Button } from "primereact/button";
import { Responsive, WidthProvider } from "react-grid-layout";
import { Col, Row} from 'react-bootstrap';
import "react-grid-layout/css/styles.css";
import "react-resizable/css/styles.css";
import { Avatar } from 'primereact/avatar';
import { InputTextarea } from "primereact/inputtextarea";
import { Dialog } from "primereact/dialog";
import Cropper from "react-easy-crop";
import getCroppedImg from "./cropImage";

const ResponsiveGridLayout = WidthProvider(Responsive);

const Attachment = () => {
    const [showCommentId, setShowCommentId] = useState(null);
    const [value, setValue] = useState('');

    // Sample static data mimicking your Sequelize model structure
    const staticData = [
        {
            image_id: 1,
            card_section_id: 101,
            uploaded_date: "2025-04-11T12:00:00Z",
            filename: "img1.jpg",
            cdn_url: "https://primefaces.org/cdn/primereact/images/organization/walter.jpg",
            x: 0,
            y: 0,
            w: 1,
            h: 1,
            cluster_id: "clusterA"
        },
        {
            image_id: 2,
            card_section_id: 102,
            uploaded_date: "2025-04-11T12:10:00Z",
            filename: "img2.jpg",
            cdn_url: "https://info.ehl.edu/hubfs/Blog-EHL-Insights/Blog-Header-EHL-Insights/private-jet-standard.jpg",
            x: 1,
            y: 0,
            w: 1,
            h: 1,
            cluster_id: "clusterB"
        },
        {
            image_id: 3,
            card_section_id: 103,
            uploaded_date: "2025-04-11T12:20:00Z",
            filename: "img3.jpg",
            cdn_url: "https://primefaces.org/cdn/primereact/images/organization/walter.jpg",
            x: 0,
            y: 2,
            w: 1,
            h: 1,
            cluster_id: "clusterC"
        },
        {
            image_id: 4,
            card_section_id: 103,
            uploaded_date: "2025-04-11T12:20:00Z",
            filename: "img3.jpg",
            cdn_url: "https://info.ehl.edu/hubfs/Blog-EHL-Insights/Blog-Header-EHL-Insights/private-jet-standard.jpg",
            x: 2,
            y: 0,
            w: 1,
            h: 1,
            cluster_id: "clusterC"
        }
        
    ];

    // Convert static data into layouts
    const layout = staticData.map((img, index) => ({
        i: img.image_id.toString(),
        x: img.x,
        y: img.y,
        w: img.w,
        h: img.h
    }));

    /*------------Image Cropper----------------*/

    const [showCrop, setShowCrop] = useState(false);
    const [cropData, setCropData] = useState(null);
    const [crop, setCrop] = useState({ x: 0, y: 0 });
    const [zoom, setZoom] = useState(1);
    const [croppedAreaPixels, setCroppedAreaPixels] = useState(null);

    const handleCropComplete = (croppedArea, croppedPixels) => {
        setCroppedAreaPixels(croppedPixels);
    };

    const handleDownload = async () => {
        const croppedImage = await getCroppedImg(cropData.url, croppedAreaPixels);
        const link = document.createElement("a");
        link.href = croppedImage;
        link.download = `cropped-image-${cropData.imageId}.jpeg`;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        setShowCrop(false);
    };

    return (
        <>
            <div className="d-flex justify-content-between align-items-start">
                <h6><i className="pi pi-paperclip me-2"></i> <b>Attachment</b></h6>
            </div>
            <label className="mb-3">File</label>

            <Row>
                <Col lg={12} md={12} sm={12} className="p-0">
                    <ResponsiveGridLayout
                        className="layout"
                        layouts={{ lg: layout }}
                        breakpoints={{ lg: 1200, md: 996, sm: 768, xs: 480, xxs: 0 }}
                        cols={{ lg: 12, md: 10, sm: 6, xs: 4, xxs: 2 }}
                        rowHeight={100}
                        isDraggable={true}
                        draggableCancel=".no-drag"
                    >
                        {staticData.map((img) => (
                            <div
                                key={img.image_id.toString()}
                                style={{
                                    borderRadius: "8px",
                                    position: "relative",
                                }}
                            >
                                <img
                                    src={img.cdn_url}
                                    alt="img"
                                    style={{
                                        width: "100%",
                                        height: "100%",
                                        objectFit: "cover",
                                        overflow: "hidden",
                                    }}
                                />
                                <div className="imGbuttonList no-drag">
                                    <div className="position-relative">
                                        <Button
                                            icon="pi pi-comments"
                                            tooltip="Comment"
                                            className="border-0 p-1"
                                            text
                                            onClick={() =>
                                                setShowCommentId(prev => prev === img.image_id ? null : img.image_id)
                                            }
                                        />
                                        <span 
                                        style={{
                                            position: 'absolute', 
                                            top: '-10px', 
                                            right: '-10px', 
                                            background: 'rgb(228 45 119)',
                                            color: '#fff',
                                            borderRadius: '50%', 
                                            width: '20px', 
                                            height: '20px', 
                                            display: 'flex', 
                                            alignItems: 'center', 
                                            justifyContent: 'center',
                                            fontSize: '9px',
                                            }}
                                        >
                                            50
                                        </span>
                                    </div>
                                    
                                    <Button
                                        icon="pi pi-expand"
                                        tooltip="Crop"
                                        className="border-0 p-1"
                                        text
                                        onClick={() => {
                                            setCropData({ url: img.cdn_url, imageId: img.image_id });
                                            setShowCrop(true);
                                        }}
                                    />
                                    <Button
                                        icon="pi pi-download"
                                        tooltip="Download"
                                        className="border-0 p-1"
                                        text
                                        onClick={() => {
                                            const link = document.createElement("a");
                                            link.href = img.cdn_url;
                                            link.download = `image-${img.image_id}.jpeg`;
                                            document.body.appendChild(link);
                                            link.click();
                                            document.body.removeChild(link);
                                        }}
                                    />
                                </div>
                            </div>
                        ))}
                    </ResponsiveGridLayout>
                </Col>
                <div className="p-0">
                    {/* Comment popup shown outside the grid layout */}
                    {showCommentId && (
                        <div className="img-comment mt-3">
                            <Button
                                icon="pi pi-times"
                                className="p-button-text p-button-sm cmtclose no-drag p-0"
                                style={{
                                    position: "absolute"
                                }}
                                onClick={() => setShowCommentId(null)}
                            />
                            <div className="d-flex gap-2 comDiv">
                                <Avatar label="U" style={{ backgroundColor: '#9c27b0', color: '#ffffff', width:'25px', height:'25px' }} shape="circle" />
                                <p style={{width: 'calc(100% - 50px)'}}>
                                    <span>
                                        This is the comment box with an image or any content.
                                        <small>11/03/2025 12:00 PM</small>
                                    </span>
                                </p>
                            </div>
                            <div className="mt-4 text-end">
                                <InputTextarea 
                                    value={value} 
                                    onChange={(e) => setValue(e.target.value)} 
                                    className="px-2 py-1" 
                                    placeholder="Write a comment..."
                                />
                                <Button
                                    label="Save"
                                    className="py-1 border-0 ms-2"
                                    severity="warning"
                                />
                            </div>
                        </div>
                    )}
                </div>

                <Dialog
                    header="Crop Image"
                    visible={showCrop}
                    onHide={() => setShowCrop(false)}
                    style={{ width: "50vw" }}
                    breakpoints={{ '960px': '75vw', '640px': '100vw' }}
                >
                    {cropData && (
                        <div style={{ position: "relative", width: "100%", height: 400 }}>
                            <Cropper
                                image={cropData.url}
                                crop={crop}
                                zoom={zoom}
                                aspect={4 / 3}
                                onCropChange={setCrop}
                                onZoomChange={setZoom}
                                onCropComplete={handleCropComplete}
                            />
                        </div>
                    )}
                    <div className="mt-3 text-right">
                        <Button label="Save & Download" icon="pi pi-save" onClick={handleDownload} />
                    </div>
                </Dialog>
            </Row>
        </>
    );
};

export default Attachment;
